<section class="team-hero-area fixed-height parallaxBg bg-img" data-bg="assets/img/gerencia/fondo-requisitos.jpg"
    style="background-image: none;"
    data-jarallax-original-styles="background-image: url(&quot;assets/img/team/fondo-gerencia.jpg&quot;);">
    <div class="container h-100">
        <div class="row team-member-item h-100">
            <div class="col-lg-7 text-center m-auto">
                <div class="about-us-content white mt-70 mt-sm-50">
                    <h2 style="font-size: 35px; margin-bottom: 0px; line-height: 1.4;">Gerencia del Centro
                        Histórico</h2>
                    <p style="font-weight:200;">Requisitos para licencias de: obra, remodelaciones, demoliciones, edificaciones y conformidades de obra.</p>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="welcome-section pb-100 pb-md-60 pb-sm-40 pt-80 bg-offwhite" style="background-image: url('/assets/img/fondo-rosario.png'); background-size: cover;
    background-position: center;">
  <div class="container">
      <div class="row">
          <!-- Start Section title -->
          <div class="col-lg-6 m-auto text-center">
              <div class="section-title-wrap">
                  <h2>REQUISITOS PARA LICENCIAS</h2>
                  <p class="mb-0" style="font-weight: 300">A continuación se lista la lista de requisitos para los trámites más importantes</p>
              </div>
          </div><!-- End Section title -->
      </div>
      <div class="row">
          <div class="col-12">
              <table class="table">
                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td><a href="assets/pdf/requisitos/Licencia_Obra_Nueva.pdf" target="_blank"> Requisitos para licencia de obra nueva Modalidad «C» </a></td>
                      <td><img src="assets/img/download.svg" alt="" width="40px"> </td>
                    </tr>
                    <tr>
                      <th scope="row">2</th>
                      <td><a href="assets/pdf/requisitos/Licencia_Obra_Remodelacion.pdf" target="_blank">Requisitos para licencia de remodelaciones, ampliaciones Modalidad «C»</a></td>
                      <td><img src="assets/img/download.svg" alt="" width="40px"> </td>
                    </tr>
                    <tr>
                      <th scope="row">3</th>
                      <td><a href="assets/pdf/requisitos/Licencia_Obra_Demolicion.pdf" target="_blank">Requisitos para licencia de demoliciones, parciales o totales Modalidad «C»</a></td>
                      <td><img src="assets/img/download.svg" alt="" width="40px"> </td>
                    </tr>
                    <tr>
                      <th scope="row">4</th>
                      <td><a href="assets/pdf/requisitos/Procedimientos_Complementarios.pdf" target="_blank">Procedimientos Complementarios a la Edificación Anteproyecto en Consulta C y D</a></td>
                      <td><img src="assets/img/download.svg" alt="" width="40px"> </td>
                    </tr>
                    <tr>
                      <th scope="row">5</th>
                      <td><a href="assets/pdf/requisitos/Conformidad_Obra.pdf" target="_blank">Requisitos y procedimiento para otorgar la conformidad de obra y la declaratoria de edificación sin variaciones Modalidad C</a></td>
                      <td><img src="assets/img/download.svg" alt="" width="40px"> </td>
                    </tr>
                  </tbody>
                </table>

          </div>
      </div>
  </div>
</section>
